import React, { useEffect, useState } from "react";
import { getRtiAlertDetails } from "../../../services/AppService";
import { useLocation, useNavigate } from "react-router-dom";
import PageFade from "../../../components/Login/PageFade";
import closeButton from '../../../assets/images/close.png';
import ViewRtiAlertDetailsModal from "./ViewRtiAlertDetailsModal";
import { useTranslation } from "react-i18next";

const RtiAlertDetailsPage = () => {
    const {t}=useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const type = location.state?.type || "New RTI";

    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [items, setItems] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    
    const [selectedRti, setSelectedRti] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        fetchRtiDetails();
    }, [page, size, type]);

    const fetchRtiDetails = async () => {
        setLoading(true);
        try {
            const res = await getRtiAlertDetails(type, page, size);
            if (res) {
                setItems(res.content || []);
                setTotalPages(res.totalPages || 0);
                setTotalElements(res.totalElements || 0);
            }
        } catch (error) {
            console.error("Error fetching RTI alerts", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-blue">{type==="New RTI" && (t('pageTitles.newRtiDetails'))}
                        {type==="RTI 14 Days" && (t('pageTitles.rtiDetails14Days'))}
                        {type==="RTI 28 Days" && (t('pageTitles.rtiDetails28Days'))}
                    </h4>
                    <img src={closeButton} className="w-6 h-6 cursor-pointer" onClick={() => navigate(-1)} alt="close" />
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full border text-sm ctable text-center">
                        <thead>
                            <tr className="bg-[#a0adf1] text-white">
                                <th className="p-3 border">{t('tables.srNo')}.</th>
                                <th className="p-3 border text-left">{t('complaint.complainerName')}</th>
                                <th className="p-3 border text-left">{t('complaint.complainAgainst')}</th>
                                <th className="p-3 border">{t('complaint.department')}</th>
                                <th className="p-3 border">{t('tables.view')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="p-4">Loading...</td></tr>
                            ) : items.length === 0 ? (
                                <tr><td colSpan="5" className="p-4 text-gray-500">No records found</td></tr>
                            ) : (
                                items.map((item, idx) => (
                                    <tr key={item.id} className="hover:bg-gray-50">
                                        <td className="p-3 border">{page * size + idx + 1}</td>
                                        <td className="p-3 border text-left font-medium">{item.complainerName}</td>
                                        <td className="p-3 border text-left">{item.rtiAgainst}</td>
                                        <td className="p-3 border">{item.departmentName}</td>
                                        <td className="p-3 border">
                                            <button 
                                                className="btnImgView"
                                                onClick={() => { setSelectedRti(item); setShowModal(true); }}
                                            ></button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <ViewRtiAlertDetailsModal 
                    data={selectedRti} 
                    onClose={() => setShowModal(false)} 
                />
            )}
        </PageFade>
    );
};

export default RtiAlertDetailsPage;